import FormObserver from './form.observer';
import scrollTo from './form.scroll';
import FormValidator from './validator.factory';
import FormItem from './item/item.module';

export default class FormModule {
  static Item = FormItem;

  static Validator = FormValidator;

  static scrollTo = scrollTo;

  $submit = () => Promise.resolve();

  constructor(model, submit) {
    this.$observer = new FormObserver();
    this.model = model;
    this.name = '';
    this.el = null;
    this.items = [];
    this.rules = [];
    this.show = false;
    this.loading = false;
    this.$disabled = false;
    if (submit) {
      this.$submit = submit;
    }
    this.parent = null;
  }

  get observer() {
    return this.parent ? this.parent.observer : this.$observer;
  }

  get disabled() {
    return this.$disabled || this.parent?.disabled || false;
  }

  set disabled(value) {
    this.$disabled = value;
  }

  set(item, name) {
    item.parent = this;
    this.items.push(item);
    if (item.name) {
      this[item.name] = item;
    }
    if (name) {
      this[name] = item;
    }
  }

  setSubmit(submit) {
    this.$submit = submit;
  }

  scrollToError({ el, top } = {}) {
    FormModule.scrollTo(el || this.el?.$el, top);
  }

  get(name) {
    return this[name];
  }

  reset() {
    this.items.forEach((i) => {
      i.reset();
    });
  }

  re() {
    this.items.forEach((i) => {
      i.re();
    });
  }

  cancel() {
    this.items.forEach((i) => {
      i.cancel();
    });
  }

  update() {
    this.items.forEach((i) => {
      i.update();
    });
  }

  validate() {
    const self = this;
    return new Promise((resolve, reject) => {
      if (!this.show) {
        resolve();
        return;
      }
      Promise
        .all([
          ...self.rules.map(i => i.validate()),
          ...self.items.map(i => i.validate()),
        ])
        .then(() => resolve(), reject);
    });
  }

  emit(name, data = null) {
    if (!this.el) {
      return;
    }
    this.el.$emit(name, data);
  }

  async submit() {
    const self = this;
    self.loading = true;
    try {
      await self.validate();
      self.emit('submit');
      const submitChild = self.items.map(i => i.submit());
      await Promise.all(submitChild);
      await self.$submit(self);
      self.update();
      self.emit('accept', self);
      return Promise.resolve();
    } catch (e) {
      self.emit('error', self);
      return Promise.reject(e);
    } finally {
      self.emit('finally', self);
      self.loading = false;
    }
  }
}
